import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {Box, Typography, Button, Stack, IconButton, Paper} from 'views/components';
import {MarkdownViewer, MarkdownEditor, Translate, translate} from 'views/module';
import {Edit as EditIcon, AssignmentOutlined as AssignmentIcon} from 'views/icons';

const CareRoutine = (props) => {
  const {careRoutine, onSave} = props;
  const [editing, setEditing] = useState(false);
  const [clientPreferences, setClientPreferences] = useState(careRoutine.clientPreferences.blob);
  const [dailyTasks, setDailyTasks] = useState(careRoutine.dailyTasks.blob);
  const [mouseOver, setMouseOver] = useState(false);

  const handleSave = () => {
    const updatedSection = {
      careRoutine: {
        clientPreferences: {
          blob: clientPreferences,
          editorType: 'MARKDOWN',
        },
        dailyTasks: {
          blob: dailyTasks,
          editorType: 'MARKDOWN',
        },
      },
    };
    onSave(updatedSection);
    setEditing(false);
  };

  const handleCancel = () => {
    setClientPreferences(careRoutine.clientPreferences.blob);
    setDailyTasks(careRoutine.dailyTasks.blob);
    setEditing(false);
  };

  return (
    <Paper
      sx={{
        borderRadius: 3,
        overflow: 'hidden',
      }}
      onMouseOver={() => setMouseOver(true)}
      onMouseLeave={() => setMouseOver(false)}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 2,
          py: 1,
          backgroundColor: 'grey.100',
          justifyContent: 'space-between',
          borderRadius: '4px 4px 0 0',
          width: '100%',
        }}
      >
        <Box sx={{display: 'flex', alignItems: 'center'}}>
          < AssignmentIcon sx={{mr: 1}} />
          <Typography variant="h6">
            <Translate expression="client.ClientDetail.Careplan.CareRoutine.Title" />
          </Typography>
        </Box>
        <IconButton
          sx={{
            visibility: editing ? 'hidden' : 'visible',
            opacity: mouseOver ? 1 : 0,
            transition: 'opacity 0.2s',
          }}
          onClick={() => setEditing(true)}
        >
          <EditIcon />
        </IconButton>
      </Box>
      <Box sx={{p: 2}}>
        {
          editing ? (
            <>
              <Typography variant="subtitle1" sx={{mb: 1, fontWeight: 'bold'}}>
                <Translate expression="client.ClientDetail.Careplan.CareRoutine.ClientPreferences" />
              </Typography>
              <MarkdownEditor
                value={clientPreferences}
                onChange={setClientPreferences}
              />
              <Typography variant="subtitle1" sx={{mt: 2, mb: 1, fontWeight: 'bold'}}>
                <Translate expression="client.ClientDetail.Careplan.CareRoutine.Tasks" />
              </Typography>
              <MarkdownEditor
                value={dailyTasks}
                onChange={setDailyTasks}
              />
              <Stack direction="row" justifyContent="flex-end" spacing={1} pt={1}>
                <Button onClick={handleCancel}>
                  <Translate expression="generic.Cancel" />
                </Button>
                <Button
                  variant="contained"
                  onClick={handleSave}
                  sx={{minWidth: '100px'}}
                >
                  <Translate expression="generic.Save" />
                </Button>
              </Stack>
            </>
          ) : (
            <>
              <Typography variant="subtitle1" sx={{mb: 1, fontWeight: 'bold'}}>
                <Translate expression="client.ClientDetail.Careplan.CareRoutine.ClientPreferences" />
              </Typography>
              <MarkdownViewer
                value={clientPreferences || translate('client.ClientDetail.Careplan.CareRoutine.NoPreferences')}
                truncate={true}
              />
              <Typography variant="subtitle1" sx={{mt: 2, mb: 1, fontWeight: 'bold'}}>
                <Translate expression="client.ClientDetail.Careplan.CareRoutine.Tasks" />
              </Typography>
              <MarkdownViewer
                value={dailyTasks || translate('client.ClientDetail.Careplan.CareRoutine.NoTasks')}
                truncate={true}
              />
            </>
          )
        }
      </Box>
    </Paper>
  );
};

CareRoutine.propTypes = {
  careRoutine: PropTypes.shape({
    clientPreferences: PropTypes.shape({
      blob: PropTypes.string,
      editorType: PropTypes.string,
    }),
    dailyTasks: PropTypes.shape({
      blob: PropTypes.string,
      editorType: PropTypes.string,
    }),
  }).isRequired,
  onSave: PropTypes.func.isRequired,
};

export default CareRoutine;
